import { ListConfig } from '../types.js'

export const buildListOptions = (list: ListConfig | undefined): ListConfig => {
  return {
    fields: ['name', 'description', 'updatedAt'],
    details: [],
    ...list
  }
}
